import type { AppType } from '@rpc/index';
import { message } from 'antd';
import { hc } from 'hono/client';
export interface ApiResponse<T = unknown> {
  code: number;
  msg: string;
  data: T;
}
export const getToken = (): string | null => localStorage.getItem('token');
export const setToken = (token: string): void =>
  localStorage.setItem('token', token);
export const clearToken = (): void => localStorage.removeItem('token');
const API_BASE_URL = process.env.UMI_APP_API_BASE_URL as string;
if (API_BASE_URL && typeof window !== 'undefined') {
  localStorage.setItem('api_base_url', API_BASE_URL);
}
const customFetch = async (
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> => {
  const token = getToken();
  const headers: HeadersInit = { ...(init?.headers as Record<string, string>) };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  if (!(init?.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }
  const response = await fetch(input, { ...init, headers });
  const json: ApiResponse = await response.json();
  if (json.code !== 0) {
    if (json.code === 401) {
      clearToken();
      message.error(json.msg || '登录状态已失效，请重新登录');
      setTimeout(() => {
        window.location.href = '/login';
      }, 1000);
      throw new Error(json.msg || '登录状态已失效');
    }
    message.error(json.msg || '系统繁忙，请稍后重试');
    throw new Error(json.msg || '系统繁忙');
  }
  return {
    ok: response.ok,
    status: response.status,
    json: async () => json,
  } as Response;
};
export const client = hc<AppType>(API_BASE_URL, { fetch: customFetch });
